import { render } from "./purchase-report-invoice.vue?vue&type=template&id=6d351601&scoped=true"
import script from "./purchase-report-invoice.vue?vue&type=script&lang=js"
export * from "./purchase-report-invoice.vue?vue&type=script&lang=js"

import "./purchase-report-invoice.vue?vue&type=style&index=0&id=6d351601&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d351601"]])

export default __exports__